var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon17MenuManageStockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38424_584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00781 5.00781V20.0078H18V22H3C2.71875 22 2.47656 21.9062 2.27344 21.7188C2.08594 21.5156 1.99219 21.2734 1.99219 20.9922V5.00781H4.00781ZM19.9922 2.99219C20.2734 2.99219 20.5078 3.09375 20.6953 3.29688C20.8984 3.48438 21 3.71875 21 4V17.9922C21 18.2734 20.8984 18.5156 20.6953 18.7188C20.5078 18.9062 20.2734 19 19.9922 19H6C5.71875 19 5.47656 18.9062 5.27344 18.7188C5.08594 18.5156 4.99219 18.2734 4.99219 17.9922V4C4.99219 3.71875 5.08594 3.48438 5.27344 3.29688C5.47656 3.09375 5.71875 2.99219 6 2.99219H19.9922ZM19.0078 17.0078V5.00781H7.00781V17.0078H19.0078ZM7.99219 7V8.99219H18V7H7.99219ZM7.99219 10V11.9922H18V10H7.99219ZM7.99219 13V14.9922H15V13H7.99219Z",
    fill: "#46B476"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38424_584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon17MenuManageStockIcon);
export default __webpack_public_path__ + "static/media/icon17_menuManageStockIcon.29a9102450c747373918ce33163d58b3.svg";
export { ForwardRef as ReactComponent };